module.exports = __webpack_public_path__ + "static/media/iconeranking.96065a29.svg";